import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AcademicService {

   baseUrl = environment.baseUrl;

  //baseUrl: string;

  constructor(private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    //this.baseUrl = appConfigService.baseUrl;
    //console.log('this.baseUrl',this.baseUrl);
    
   }
  

  searchCourseDefinition(terms: Observable<string>): any {
    return terms.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((term: string) => this.CourseDefinitionEntries(term))
    );
  }


  
  CourseDefinitionEntries(term: string): Observable<object> {
    if (term === '') {
      return of({});
    }
    const url = `${this.baseUrl + `academic_GraduationPlanTemplate/search/${term}/term`}`;
    return this.http.get(url);
  }


  searchCourseReconciliation(terms: Observable<string>): any {
    return terms.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((term: string) => this.CourseReconciliation(term))
    );
  }


  
  CourseReconciliation(term: string): Observable<object> {
    if (term === '') {
      return of({});
    }
    const url = `${this.baseUrl + `mIS_StudentEnrolment/${term}/term`}`;
    return this.http.get(url);
  }


  searchCourse(terms: Observable<string>): any {
    return terms.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((term: string) => this.CourseDefinitionEntries(term))
    );
  }


  
  CourseEntries(term: string): Observable<object> {
    if (term === '') {
      return of({});
    }
    const url = `${this.baseUrl + `academic_CourseDefinition/search/${term}/term`}`;
    return this.http.get(url);
  }


  searchCourseForSchedule(terms: Observable<string>): any {
    return terms.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((term: string) => this.CourseForSchedule(term))
    );
  }


  
  getCourseRegistrationByStudent(data) {
    return this.http.post(this.baseUrl + `academic_ResultPosting/result-by-student`,data);
  } 

  GetStudentResultByProgrammeByStudent(data) {
    return this.http.post(this.baseUrl + `academic_ResultPosting/result-approval`,data);
  } 

  
  CourseForSchedule(term: string): Observable<object> {
    if (term === '') {
      return of({});
    }
    const url = `${this.baseUrl + `academic_GraduationPlanTemplate/schedule/${term}/term`}`;
    return this.http.get(url);
  }


  searchCoursePlanning(terms: Observable<string>): any {
    return terms.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((term: string) => this.CoursePlanningEntries(term))
    );
  }


  
  CoursePlanningEntries(term: string): Observable<object> {
    if (term === '') {
      return of({});
    }
    const url = `${this.baseUrl + `academic_CourseSchedule/${term}/term`}`;
    return this.http.get(url);
  }
  


  CourseCurriculumEntries(term: string): Observable<object> {
    if (term === '') {
      return of({});
    }
    const url = `${this.baseUrl + `academic_Curriculum/search/${term}/term`}`;
    return this.http.get(url);
  }
  
  searchCourseTemplet(terms: Observable<string>): any {
    return terms.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((term: string) => this.CourseTemplateEntries(term))
    );
  }

  CourseTemplateEntries(term: string): Observable<object> {
    if (term === '') {
      return of({});
    }
    const url = `${this.baseUrl + `academic_GraduationPlanTemplate/search/${term}/term`}`;
    return this.http.get(url);
  }


    ScheduledCourseTemplate(term, academicDegreeProgrammeId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlanTemplate/course/${term}/term/${academicDegreeProgrammeId}/academicDegreeProgrammeId`);
  }

  searchScheduledCourses(terms: Observable<string>): any {
    return terms.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((term: string) => this.ScheduledCoursesEntries(term))
    );
  }

  ScheduledCoursesEntries(term: string): Observable<object> {
    if (term === '') {
      return of({});
    }
    const url = `${this.baseUrl + `academic_GraduationPlanTemplate/scheduled-course/${term}/term`}`;
    return this.http.get(url);
  }

  searchCourseCourriculum(terms: Observable<string>): any {
    return terms.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((term: string) => this.CourseCurriculumEntries(term))
    );
  }

  CourseCourriculumEntries(term: string): Observable<object> {
    if (term === '') {
      return of({});
    }
    const url = `${this.baseUrl + `academic_Curriculum/search/${term}/term`}`;
    return this.http.get(url);
  }


  submitAcademic_AssessmentTool(data) {
    return this.http.post(this.baseUrl + `academic_AssessmentTool`,data);
  }
  getAcademic_AssessmentTool() {
    return this.http.get(this.baseUrl + `academic_AssessmentTool`);
  }
  deleteAcademic_AssessmentTool(academicAssessmentToolId) {
    return this.http.delete(this.baseUrl + `academic_AssessmentTool/${academicAssessmentToolId}/academicAssessmentToolId`);
  }
  updateAcademic_AssessmentTool(data,academicAssessmentToolId) {
    return this.http.put(this.baseUrl + `academic_AssessmentTool/${academicAssessmentToolId}/academicAssessmentToolId`, data);
  }



  submitAcademic_Calendar(data) {
    return this.http.post(this.baseUrl + `academic_Calendar`,data);
  }
  getAcademic_Calendar() {
    return this.http.get(this.baseUrl + `academic_Calendar`);
  }
  deleteAcademic_Calendar(academicCalendarId) {
    return this.http.delete(this.baseUrl + `academic_Calendar/${academicCalendarId}/academicCalendarId`);
  }
  updateAcademic_Calendar(data,academicCalendarId) {
    return this.http.put(this.baseUrl + `academic_Calendar/${academicCalendarId}/academicCalendarId`, data);
  }

  submitAcademic_CourseCategory(data) {
    return this.http.post(this.baseUrl + `academic_CourseCategory`,data);
  }
  getAcademic_CourseCategory() {
    return this.http.get(this.baseUrl + `academic_CourseCategory`);
  }
  deleteAcademic_CourseCategory(academicCourseCategoryId) {
    return this.http.delete(this.baseUrl + `academic_CourseCategory/${academicCourseCategoryId}/academicCourseCategoryId`);
  }

  deleteTimetableSchedule(academicTimeTableId) {
    return this.http.delete(this.baseUrl + `academic_TimeTable/${academicTimeTableId}/academicTimeTableId`);
  }

  updateAcademic_CourseCategory(data,academicCourseCategoryId) {
    return this.http.put(this.baseUrl + `academic_CourseCategory/${academicCourseCategoryId}/academicCourseCategoryId`, data);
  }


  submitAcademic_CourseDefinition(data) {
    return this.http.post(this.baseUrl + `academic_CourseDefinition`,data);
  }

  searchRecord(data) {
    return this.http.post(this.baseUrl + `academic_CourseDefinition/search`,data);
  }


  getStudentList(data) {
    return this.http.post(this.baseUrl + `mIS_Student/list`,data);
  }

  GetProgrammes(academicDepartmentId) {
    return this.http.get(this.baseUrl + `academic_DegreeProgramme/${academicDepartmentId}/academicDepartmentId`);
  }

  searchRecordForPlan(data) {
    return this.http.post(this.baseUrl + `academic_GraduationPlanTemplate/template`,data);
  }

  getAcademic_CourseDefinition() {
    return this.http.get(this.baseUrl + `academic_CourseDefinition`);
  }
  deleteAcademic_CourseDefinition(academicCourseDefinitionId) {
    return this.http.delete(this.baseUrl + `academic_CourseDefinition/${academicCourseDefinitionId}/academicCourseDefinitionId`);
  }
  updateAcademic_CourseDefinition(data,academicCourseDefinitionId) {
    return this.http.put(this.baseUrl + `academic_CourseDefinition/${academicCourseDefinitionId}/academicCourseDefinitionId`, data);
  }



  submitAcademic_Level(data) {
    return this.http.post(this.baseUrl + `academic_Level`,data);
  }
  getAcademic_Level() {
    return this.http.get(this.baseUrl + `academic_Level`);
  }
  getAcademic_Levels(academicDegreeProgrammeId) {
    return this.http.get(this.baseUrl + `academic_Level/${academicDegreeProgrammeId}/academicDegreeProgrammeId`);
  }

  getAdmin_RequireDocument(documentUploadId,data) {
    return this.http.put(this.baseUrl + `application_DocumentUpload/${documentUploadId}/documentUploadId`,data);
  }


  getFaculty(academicDegreeTypeId) {
    return this.http.get(this.baseUrl + `academic_DegreeProgramme/${academicDegreeTypeId}/academicDegreeTypeId`);
  }

  getDepartment(academicFacultyId) {
    return this.http.get(this.baseUrl + `academic_DegreeProgramme/${academicFacultyId}/academicFacultyId`);
  }

  getProgramme(academicDepartmentId) {
    return this.http.get(this.baseUrl + `academic_DegreeProgramme/${academicDepartmentId}/academicDepartmentId`);
  }

  getProgrammeByDegreeType(academicDegreeTypeId) {
    return this.http.get(this.baseUrl + `academic_DegreeProgramme/programme/${academicDegreeTypeId}/academicDegreeTypeId`);
  }

  deleteAcademic_Level(academicLevelId) {
    return this.http.delete(this.baseUrl + `academic_Level/${academicLevelId}/academicLevelId`);
  }
  updateAcademic_Level(data,academicLevelId) {
    return this.http.put(this.baseUrl + `academic_Level/${academicLevelId}/academicLevelId`, data);
  }


  submitAcademic_Curriculum(data) {
    return this.http.post(this.baseUrl + `academic_Curriculum`,data);
  }

  resultProcessingPerStudent(data) {
    return this.http.post(this.baseUrl + `academic_ResultPosting/result-processing-student`,data);
  }

  directResultProcessingPerStudent(data) {
    return this.http.post(this.baseUrl + `academic_ResultPosting/direct-result-processing`,data);
  }

  processResult(data) {
    return this.http.post(this.baseUrl + `academic_ResultPosting/result-processing`,data);
  }
  publishResult(data) {
    return this.http.post(this.baseUrl + `academic_ResultPosting/publish-result`,data);
  }

  getAcademic_Curriculum() {
    return this.http.get(this.baseUrl + `academic_Curriculum`);
  }
  deleteAcademic_Curriculum(academicCurriculumId) {
    return this.http.delete(this.baseUrl + `academic_Curriculum/${academicCurriculumId}/academicCurriculumId`);
  }
  updateAcademic_Curriculum(data,academicCurriculumId) {
    return this.http.put(this.baseUrl + `academic_Curriculum/${academicCurriculumId}/academicCurriculumId`, data);
  }


  submitAcademic_CourseRegistration(data) {
    return this.http.post(this.baseUrl + `academic_CourseRegistration`,data);
  }
  getAcademic_CourseRegistration() {
    return this.http.get(this.baseUrl + `academic_CourseRegistration`);
  }
  deleteAcademic_CourseRegistration(courseRegistrationId) {
    return this.http.delete(this.baseUrl + `academic_CourseRegistration/${courseRegistrationId}/courseRegistrationId`);
  }
  updateAcademic_CourseRegistration(data,courseRegistrationId) {
    return this.http.put(this.baseUrl + `academic_CourseRegistration/${courseRegistrationId}/courseRegistrationId`, data);
  }



  getAcademic_ActiveSemester() {
    return this.http.get(this.baseUrl + `academicActiveSemesterMaster`);
  }
  submitAcademic_CourseSchedule(data) {
    return this.http.post(this.baseUrl + `academic_CourseSchedule`,data);
  }
  getScheduledCoursesForTimetalbe(data) {
    return this.http.post(this.baseUrl + `academic_CourseSchedule/timetable`,data);
  }

  viewResult(studentId) {
    return this.http.get(this.baseUrl + `report/result-sheet/${studentId}/studentId`);
  }

    viewTranscritResult(studentId,academicSessionId,academicSemesterId) {
    return this.http.get(this.baseUrl + `report/result-sheet/${studentId}/studentId/${academicSessionId}/academicSessionId/${academicSemesterId}/academicSemesterId`);
  }
  viewTranscritResultSession(studentId,academicSessionId) {
    return this.http.get(this.baseUrl + `report/result-sheet/${studentId}/studentId/${academicSessionId}/academicSessionId`);
  }

  getTimetalbeSetup(data) {
    return this.http.post(this.baseUrl + `academic_TimeTable/timetable`,data);
  }

  getAcademic_CourseSchedule(employeeId, sessionId,academicSemesterId) {
    return this.http.get(this.baseUrl + `academic_CourseSchedule/${employeeId}/employeeId/${sessionId}/sessionId/${academicSemesterId}/academicSemesterId`);
  }

  getCourseByProgramme(academicDegreeProgrammeId, academicSemesterId,academicSessionId,academicLevelId) {
    return this.http.get(this.baseUrl + `academic_ResultPosting/${academicDegreeProgrammeId}/academicDegreeProgrammeId/${academicSemesterId}/academicSemesterId/${academicSessionId}/academicSessionId/${academicLevelId}/academicLevelId`);
  }
  getTotalCourseRegistrationByProgramme(academicFacultyId, academicSemesterId,academicSessionId,levelOrderOfProgressing) {
    return this.http.get(this.baseUrl + `academic_ResultPosting/${academicFacultyId}/academicFacultyId/${academicSemesterId}/academicSemesterId/${academicSessionId}/academicSessionId/${levelOrderOfProgressing}/levelOrderOfProgressing`);
  }

  getAcademic_DefinedCourseSchedule(employeeId) {
    return this.http.get(this.baseUrl + `academic_CourseSchedule/course-registration/${employeeId}/employeeId`);
  }

  deleteAcademic_CourseSchedule(academicCourseScheduleId) {
    return this.http.delete(this.baseUrl + `academic_CourseSchedule/${academicCourseScheduleId}/academicCourseScheduleId`);
  }
  updateAcademic_CourseSchedule(data,academicCourseScheduleId) {
    return this.http.put(this.baseUrl + `academic_CourseSchedule/${academicCourseScheduleId}/academicCourseScheduleId`, data);
  }

  getAcademicStudentActivity(academicCourseScheduleId) {
    return this.http.get(this.baseUrl + `academic_StudentActivity/${academicCourseScheduleId}/academicCourseScheduleId`);
  }

  submitAcademic_DegreeProgramme(data) {
    return this.http.post(this.baseUrl + `academic_DegreeProgramme`,data);
  }
  getAcademic_DegreeProgramme() {
    return this.http.get(this.baseUrl + `academic_DegreeProgramme`);
  }
  deleteAcademic_DegreeProgramme(academicDegreeProgrammeId) {
    return this.http.delete(this.baseUrl + `academic_DegreeProgramme/${academicDegreeProgrammeId}/academicDegreeProgrammeId`);
  }
  updateAcademic_DegreeProgramme(data,academicDegreeProgrammeId) {
    return this.http.put(this.baseUrl + `academic_DegreeProgramme/${academicDegreeProgrammeId}/academicDegreeProgrammeId`, data);
  }



  submitAcademic_DegreeType(data) {
    return this.http.post(this.baseUrl + `academic_DegreeType`,data);
  }
  getAcademic_DegreeType() {
    return this.http.get(this.baseUrl + `academic_DegreeType`);
  }
  deleteAcademic_DegreeType(academicDegreeTypeId) {
    return this.http.delete(this.baseUrl + `academic_DegreeType/${academicDegreeTypeId}/academicDegreeTypeId`);
  }
  updateAcademic_DegreeType(data,academicDegreeTypeId) {
    return this.http.put(this.baseUrl + `academic_DegreeType/${academicDegreeTypeId}/academicDegreeTypeId`, data);
  }


  submitAcademic_Department(data) {
    return this.http.post(this.baseUrl + `academic_Department`,data);
  }
  getAcademic_Department() {
    return this.http.get(this.baseUrl + `academic_Department`);
  }
  getAcademicDepartmentByFaculty(academicFacultyId) {
    return this.http.get(this.baseUrl + `academic_Department/${academicFacultyId}/academicFacultyId`);
  }
  deleteAcademic_Department(academicDepartmentId) {
    return this.http.delete(this.baseUrl + `academic_Department/${academicDepartmentId}/academicDepartmentId`);
  }
  updateAcademic_Department(data,academicDepartmentId) {
    return this.http.put(this.baseUrl + `academic_Department/${academicDepartmentId}/academicDepartmentId`, data);
  }
  updateDepartmentAdmissionStatus(data,academicDepartmentId) {
    return this.http.put(this.baseUrl + `academic_Department/admission/${academicDepartmentId}/academicDepartmentId`, data);
  }


  submitAcademic_Faculty(data) {
    return this.http.post(this.baseUrl + `academic_Faculty`,data);
  }
  getAcademic_Faculty() {
    return this.http.get(this.baseUrl + `academic_Faculty/all`);
  }

   getAllAcademicFaculty() {
    return this.http.get(this.baseUrl + `academic_Faculty/all`);
  }
  getAcademic_FacultyByDegreeType(academicDegreeTypeId) {
    return this.http.get(this.baseUrl + `academic_Faculty/all/${academicDegreeTypeId}/academicDegreeTypeId`);
  }

  getAcademicFaculty(academicDegreeTypeId) {
    return this.http.get(this.baseUrl + `academic_Faculty/${academicDegreeTypeId}/academicDegreeTypeId`);
  }

  deleteAcademic_Faculty(academicFacultyId) {
    return this.http.delete(this.baseUrl + `academic_Faculty/${academicFacultyId}/academicFacultyId`);
  }
  updateAcademic_Faculty(data,academicFacultyId) {
    return this.http.put(this.baseUrl + `academic_Faculty/${academicFacultyId}/academicFacultyId`, data);
  }



  submitAcademic_Grade(data) {
    return this.http.post(this.baseUrl + `academic_Grade`,data);
  }
  getAcademic_Grade() {
    return this.http.get(this.baseUrl + `academic_Grade`);
  }
  deleteAcademic_Grade(academicGradeId) {
    return this.http.delete(this.baseUrl + `academic_Grade/${academicGradeId}/academicGradeId`);
  }
  updateAcademic_Grade(data,academicGradeId) {
    return this.http.put(this.baseUrl + `academic_Grade/${academicGradeId}/academicGradeId`, data);
  }


  submitAcademic_GradePointAverage(data) {
    return this.http.post(this.baseUrl + `academic_GradePointAverage`,data);
  }
  getAcademic_GradePointAverage(gradingTemplateId) {
    return this.http.get(this.baseUrl + `academic_GradePointAverage/${gradingTemplateId}/gradingTemplateId`);
  }
  deleteAcademic_GradePointAverage(gradePointAverageId) {
    return this.http.delete(this.baseUrl + `academic_GradePointAverage/${gradePointAverageId}/gradePointAverageId`);
  }
  updateAcademic_GradePointAverage(data,gradePointAverageId) {
    return this.http.put(this.baseUrl + `academic_GradePointAverage/${gradePointAverageId}/gradePointAverageId`, data);
  }



  submitAcademic_GraduationPlan(data) {
    return this.http.post(this.baseUrl + `academic_GraduationPlan`,data);
  }
  submitAddAndDrop(data) {
    return this.http.post(this.baseUrl + `academic_GraduationPlan/add-and-drop`,data);
  }
  deactivateCourseForRepeatingStudents(data) {
    return this.http.post(this.baseUrl + `academic_GraduationPlan/deactivate-courses`,data);
  }
  getAcademic_GraduationPlan() {
    return this.http.get(this.baseUrl + `academic_GraduationPlan`);
  }
  
  getAcademicGraduationPlan(academicDegreeProgrammeId,academicLevelId,academicSessionId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlan/${academicDegreeProgrammeId}/academicDegreeProgrammeId/${academicLevelId}/academicLevelId/${academicSessionId}/academicSessionId`);
  }

  getStudentCourseRegistrationStatus(academicDegreeProgrammeId,academicLevelId,academicSessionId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlan/course-registration-status/${academicDegreeProgrammeId}/academicDegreeProgrammeId/${academicLevelId}/academicLevelId/${academicSessionId}/academicSessionId`);
  }

  searchForCourseRegistration(data) {
    return this.http.post(this.baseUrl + `academic_GraduationPlan/search-student`,data);
  }
  getStudentsThatRegisteredForSemesterCourses(academicDegreeProgrammeId,academicLevelId,academicSessionId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlan/registered/${academicDegreeProgrammeId}/academicDegreeProgrammeId/${academicLevelId}/academicLevelId/${academicSessionId}/academicSessionId`);
  }
  deleteAcademic_GraduationPlan(graduationPlanId) {
    return this.http.delete(this.baseUrl + `academic_GraduationPlan/${graduationPlanId}/graduationPlanId`);
  }
  updateAcademic_GraduationPlan(data,graduationPlanId) {
    return this.http.put(this.baseUrl + `academic_GraduationPlan/${graduationPlanId}/graduationPlanId`, data);
  }
  updateGraduationPlan(data,studentId) {
    return this.http.put(this.baseUrl + `academic_GraduationPlan/${studentId}/studentId`, data);
  }

  UpdateSemesterCoursesRegistration(data,studentId) {
    return this.http.put(this.baseUrl + `academic_GraduationPlan/update/${studentId}/studentId`, data);
  }



  submitAcademic_ResultPosting(data) {
    return this.http.post(this.baseUrl + `academic_ResultPosting`,data);
  }
  submitAcademic_ResultDirectPosting(data) {
    return this.http.post(this.baseUrl + `academic_ResultDirectPosting`,data);
  }
  submitResultCorrection(data) {
    return this.http.post(this.baseUrl + `academic_ResultPosting/mark-correction`,data);
  }
  submitResultPostingAdjustment(data) {
    return this.http.post(this.baseUrl + `academic_ResultPosting/mark-adjustment`,data);
  }
  getAcademic_ResultPosting(academicSessionId,academicSemesterId,academicCourseScheduleId) {
    return this.http.get(this.baseUrl + `academic_ResultPosting/${academicSessionId}/academicSessionId/${academicSemesterId}/academicSemesterId/${academicCourseScheduleId}/academicCourseScheduleId`);
  }

  getChangeOfProgramme() {
    return this.http.get(this.baseUrl + `mIS_StudentEnrolment/cop`);
  }

  getCourseForReconciliation(studentId,academicLevelId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlan/${studentId}/studentId/${academicLevelId}/academicLevelId`);
  }

  getCourseReconciliation(studentId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlan/${studentId}/studentId`);
  }

  getAcademic_ResultPostingByFaculty(academicSessionId,academicSemesterId,academicCourseScheduleId,employeeId) {
    return this.http.get(this.baseUrl + `academic_ResultPosting/${academicSessionId}/academicSessionId/${academicSemesterId}/academicSemesterId/${academicCourseScheduleId}/academicCourseScheduleId/${employeeId}/employeeId`);
  }

  getStudentResultByProgramme(academicSessionId,academicSemesterId,academicDegreeProgrammeId,academicLevelId) {
    return this.http.get(this.baseUrl + `academic_ResultPosting/${academicSessionId}/academicSessionId/${academicSemesterId}/academicSemesterId/${academicDegreeProgrammeId}/academicDegreeProgrammeId/${academicLevelId}/academicLevelId`);
  }

  getStudentDirectResultByProgramme(academicSessionId,academicSemesterId,academicDegreeProgrammeId,academicLevelId) {
    return this.http.get(this.baseUrl + `academic_ResultDirectPosting/${academicSessionId}/academicSessionId/${academicSemesterId}/academicSemesterId/${academicDegreeProgrammeId}/academicDegreeProgrammeId/${academicLevelId}/academicLevelId`);
  }

  getStudentResultApproved(academicSessionId,academicSemesterId,academicDegreeProgrammeId,academicLevelId) {
    return this.http.get(this.baseUrl + `academic_ResultPosting/approved/${academicSessionId}/academicSessionId/${academicSemesterId}/academicSemesterId/${academicDegreeProgrammeId}/academicDegreeProgrammeId/${academicLevelId}/academicLevelId`);
  }

  getAcademicResultCorrections(data) {
    return this.http.post(this.baseUrl + `academic_ResultPosting/correction-approval`,data);
  }

  getAllResultCorrections(data) {
    return this.http.post(this.baseUrl + `academic_ResultPosting/all-correction-approval`,data);
  }

  getAllResultCorrectionsByEmployee(data) {
    return this.http.post(this.baseUrl + `academic_ResultPosting/result-correction-by-employee`,data);
  }

  getStudentAssessment(studentId,academicCourseDefinitionId,academicSessionId,academicSemesterId) {
    return this.http.get(this.baseUrl + `academic_ResultPosting/${studentId}/studentId/${academicCourseDefinitionId}/academicCourseDefinitionId/${academicSessionId}/academicSessionId/${academicSemesterId}/academicSemesterId`);
  }


  getCourseRegistrationByProgramme(academicSessionId,academicSemesterId,academicCourseScheduleId,academicDegreeProgrammeId,employeeId) {
    return this.http.get(this.baseUrl + `academic_ResultPosting/${academicSessionId}/academicSessionId/${academicSemesterId}/academicSemesterId/${academicCourseScheduleId}/academicCourseScheduleId/${academicDegreeProgrammeId}/academicDegreeProgrammeId/${employeeId}/employeeId`);
  } 
  GetListOfProgrammes(academicCourseScheduleId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlan/${academicCourseScheduleId}/academicCourseScheduleId`);
  }
  GetCummulativeGradePoint(studentId,academicSessionId,academicSemesterId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlan/cgp/${studentId}/studentId/${academicSessionId}/academicSessionId/${academicSemesterId}/academicSemesterId`);
  }
  getAcademicResultPosting(academicCourseDefinitionId) {
    return this.http.get(this.baseUrl + `academic_ResultPosting/${academicCourseDefinitionId}/academicCourseDefinitionId`);
  }
  getStudentResultByCourseForApproval(academicCourseDefinitionId,academicSessionId,academicSemesterId) {
    return this.http.get(this.baseUrl + `academic_ResultPosting/senate-approval/${academicCourseDefinitionId}/academicCourseDefinitionId/${academicSessionId}/academicSessionId/${academicSemesterId}/academicSemesterId`);
  }
  getStudentResultWithFilterForApproval(academicCourseDefinitionId,academicSessionId,academicSemesterId,valueOperator,value) {
    return this.http.get(this.baseUrl + `academic_ResultPosting/senate-approval/${academicCourseDefinitionId}/academicCourseDefinitionId/${academicSessionId}/academicSessionId/${academicSemesterId}/academicSemesterId/${valueOperator}/valueOperator/${value}/value`);
  }

  deleteAcademic_ResultPosting(resultPostingId) {
    return this.http.delete(this.baseUrl + `academic_ResultPosting/${resultPostingId}/resultPostingId`);
  }
  updateAcademic_ResultPosting(data,resultPostingId) {
    return this.http.put(this.baseUrl + `academic_ResultPosting/${resultPostingId}/resultPostingId`, data);
  }

  promoteToNextLevel(data) {
    return this.http.post(this.baseUrl + `mIS_StudentEnrolment/promotion`, data);
  }

  getStudentListForLevelPrograssion(data) {
    return this.http.post(this.baseUrl + `mIS_StudentEnrolment/level-progression`, data);
  }

  submitAcademic_Semester(data) {
    return this.http.post(this.baseUrl + `academic_Semester`,data);
  }
  getAcademic_Semester() {
    return this.http.get(this.baseUrl + `academic_Semester`);
  }
  getActiveAcademic_Semester() {
    return this.http.get(this.baseUrl + `academic_Semester/active`);
  }
  deleteAcademic_Semester(academicSemesterId) {
    return this.http.delete(this.baseUrl + `academic_Semester/${academicSemesterId}/academicSemesterId`);
  }
  updateAcademic_Semester(data,academicSemesterId) {
    return this.http.put(this.baseUrl + `academic_Semester/${academicSemesterId}/academicSemesterId`, data);
  }


  submitAcademic_Session(data) {
    return this.http.post(this.baseUrl + `academic_Session`,data);
  }
  getAcademic_Session() {
    return this.http.get(this.baseUrl + `academic_Session`);
  }

  getAcademic_AdmissionSession() {
    return this.http.get(this.baseUrl + `academic_Session/admission`);
  }

  getApplicationSummaryDates(data) {
    return this.http.post(this.baseUrl + `application_Student/application-summary-dates`,data);
  }


  getApplicationSummary(academicDegreeTypeId,academicSessionId) {
    return this.http.get(this.baseUrl + `application_Student/application-summary/${academicDegreeTypeId}/academicDegreeTypeId/${academicSessionId}/academicSessionId`);
  }

  downloadApplicationSummary(academicDegreeTypeId,academicSessionId) {
    return this.http.get(this.baseUrl + `report/application-summary/${academicDegreeTypeId}/academicDegreeTypeId/${academicSessionId}/academicSessionId`, {responseType: "blob"});
  }


  getActiveAcademic_Session() {
    return this.http.get(this.baseUrl + `academic_Session`);
  }
  getAcademic_TimeTableType() {
    return this.http.get(this.baseUrl + `academic_TimeTableType`);
  }
  getStudentsCourseRegistration(academicCourseDefinitionId,sessionId,academicSemesterId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlanTemplate/students/${academicCourseDefinitionId}/academicCourseDefinitionId/${sessionId}/sessionId/${academicSemesterId}/academicSemesterId`);
  }

  deleteAcademic_Session(academicSessionId) {
    return this.http.delete(this.baseUrl + `academic_Session/${academicSessionId}/academicSessionId`);
  }
  updateAcademic_Session(data,academicSessionId) {
    return this.http.put(this.baseUrl + `academic_Session/${academicSessionId}/academicSessionId`, data);
  }


  submitAcademic_OLevelSubject(data) {
    return this.http.post(this.baseUrl + `academic_OLevelSubject`,data);
  }
  getAcademic_OLevelSubject() {
    return this.http.get(this.baseUrl + `academic_OLevelSubject`);
  }
  deleteAcademic_OLevelSubject(setupSubjectId) {
    return this.http.delete(this.baseUrl + `academic_OLevelSubject/${setupSubjectId}/setupSubjectId`);
  }
  updateAcademic_OLevelSubject(data,setupSubjectId) {
    return this.http.put(this.baseUrl + `academic_OLevelSubject/${setupSubjectId}/setupSubjectId`, data);
  }



  submitAcademic_PaymentChannel(data) {
    return this.http.post(this.baseUrl + `academic_PaymentChannel`,data);
  }
  getAcademic_PaymentChannel() {
    return this.http.get(this.baseUrl + `academic_PaymentChannel`);
  }
  deleteAcademic_PaymentChannel(paymentChannelId) {
    return this.http.delete(this.baseUrl + `academic_PaymentChannel/${paymentChannelId}/paymentChannelId`);
  }
  updateAcademic_PaymentChannel(data,paymentChannelId) {
    return this.http.put(this.baseUrl + `academic_PaymentChannel/${paymentChannelId}/paymentChannelId`, data);
  }


  submitAcademic_GraduationPlanTemplate(data) {
    return this.http.post(this.baseUrl + `academic_GraduationPlanTemplate`,data);
  }
  getAcademic_GraduationPlanTemplate() {
    return this.http.get(this.baseUrl + `academic_GraduationPlanTemplate`);
  }
  getAcademic_GraduationPlanTemplateById(academicGraduationPlanTemplateId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlanTemplate/${academicGraduationPlanTemplateId}/academicGraduationPlanTemplateId`);
  }
  deleteAcademic_GraduationPlanTemplate(academicGraduationPlanTemplateId) {
    return this.http.delete(this.baseUrl + `academic_GraduationPlanTemplate/${academicGraduationPlanTemplateId}/academicGraduationPlanTemplateId`);
  }
  updateAcademic_GraduationPlanTemplate(academicGraduationPlanTemplateId,data) {
    return this.http.put(this.baseUrl + `academic_GraduationPlanTemplate/${academicGraduationPlanTemplateId}/academicGraduationPlanTemplateId`, data);
  }


  submitAcademic_AssessmentPercentage(data) {
    return this.http.post(this.baseUrl + `academic_CourseAssessmentPercentage`,data);
  }
  getAcademic_AssessmentPercentage() {
    return this.http.get(this.baseUrl + `academic_CourseAssessmentPercentage`);
  }
  getAcademic_AssessmentPercentageById(academicCourseScheduleId) {
    return this.http.get(this.baseUrl + `academic_CourseAssessmentPercentage/${academicCourseScheduleId}/academicCourseScheduleId`);
  }
  deleteAcademic_AssessmentPercentage(academicCourseAssessmentPercentageId) {
    return this.http.delete(this.baseUrl + `academic_CourseAssessmentPercentage/${academicCourseAssessmentPercentageId}/academicCourseAssessmentPercentageId`);
  }
  updateAcademic_AssessmentPercentage(data,academicCourseAssessmentPercentageId) {
    return this.http.put(this.baseUrl + `academic_CourseAssessmentPercentage/${academicCourseAssessmentPercentageId}/academicCourseAssessmentPercentageId`, data);
  }
  
  
   getAcademicRegisteredCourses(academicCourseDefinitionId, academicSessionId,academicCourseAssessmentTypeSettingId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlan/${academicCourseDefinitionId}/academicCourseDefinitionId/${academicSessionId}/academicSessionId/${academicCourseAssessmentTypeSettingId}/academicCourseAssessmentTypeSettingId`);
  }

  getResultsForApproval(academicFacultyId, academicDepartmentId,academicCourseDefinitionId,academicDegreeProgrammeId,academicLevelId,academicSessionId,academicSemesterId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlan/${academicFacultyId}/academicFacultyId/${academicDepartmentId}/academicDepartmentId/${academicCourseDefinitionId}/academicCourseDefinitionId/${academicDegreeProgrammeId}/academicDegreeProgrammeId/${academicLevelId}/academicLevelId/${academicSessionId}/academicSessionId/${academicSemesterId}/academicSemesterId`);
  }
 
  getAcademicRegisteredByProgramme(academicCourseDefinitionId, academicSessionId,academicCourseAssessmentTypeSettingId, academicDegreeProgrammeId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlan/${academicCourseDefinitionId}/academicCourseDefinitionId/${academicSessionId}/academicSessionId/${academicCourseAssessmentTypeSettingId}/academicCourseAssessmentTypeSettingId/${academicDegreeProgrammeId}/academicDegreeProgrammeId`);
  }

  exportStudentRegistration(academicCourseDefinitionId, academicSessionId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlan/export/${academicCourseDefinitionId}/academicCourseDefinitionId/${academicSessionId}/academicSessionId`);
  }

  submitAcademic_AssessmentTypeSetting(data) {
    return this.http.post(this.baseUrl + `academic_CourseAssessmentTypeSetting`,data);
  }

  getAcademic_AssessmentTypeSetting(academicCourseScheduleId) {
    return this.http.get(this.baseUrl + `academic_CourseAssessmentTypeSetting/scheduled/${academicCourseScheduleId}/academicCourseScheduleId`);
  }
  getAcademic_AssessmentTypeSettingById(academicCourseScheduleId) {
    return this.http.get(this.baseUrl + `academic_CourseAssessmentTypeSetting/${academicCourseScheduleId}/academicCourseScheduleId`);
  }
  deleteAcademic_AssessmentTypeSetting(academicCourseAssessmentTypeSettingId) {
    return this.http.delete(this.baseUrl + `academic_CourseAssessmentTypeSetting/${academicCourseAssessmentTypeSettingId}/academicCourseAssessmentTypeSettingId`);
  }
  updateAcademic_AssessmentTypeSetting(data,academicAssessmentTypeSettingId) {
    return this.http.put(this.baseUrl + `academic_CourseAssessmentTypeSetting/${academicAssessmentTypeSettingId}/academicAssessmentTypeSettingId`, data);
  }
  getResetAssessmentTypeSetting(academicCourseScheduleId) {
    return this.http.get(this.baseUrl + `academic_CourseAssessmentTypeSetting/reset/${academicCourseScheduleId}/academicCourseScheduleId`);
  }


  getStudentView(applicationNumber) {
    return this.http.get(this.baseUrl + `application_Student/view/${applicationNumber}/applicationNumber`);
  }
  getApplication_StudentContact() {
    return this.http.get(this.baseUrl + `application_StudentContact`);
  }
  
  getStudentContact(applicationNumber) {
    return this.http.get(this.baseUrl + `application_StudentContact/${applicationNumber}/applicationNumber`);
  }
  
  getStudentContactView(applicationNumber) {
    return this.http.get(this.baseUrl + `application_StudentContact/view/${applicationNumber}/applicationNumber`);
  }
  
  getApplication_StudentContactById(studentContactId) {
    return this.http.get(this.baseUrl + `application_StudentContact/${studentContactId}/studentContactId`);
  }
  deleteApplication_StudentContact(studentContactId) {
    return this.http.delete(this.baseUrl + `application_StudentContact/${studentContactId}/studentContactId`);
  }
  updateApplication_StudentContact(data,applicationNumber) {
    return this.http.put(this.baseUrl + `application_StudentContact/${applicationNumber}/applicationNumber`, data);
  }
  getAddressView(applicationNumber) {
    return this.http.get(this.baseUrl + `application_StudentAddress/view/${applicationNumber}/applicationNumber`);
  }
  getApplicationMeansOfIdentificationView(applicationNumber) {
    return this.http.get(this.baseUrl + `application_MeansOfIdentification/view/${applicationNumber}/applicationNumber`);
  }
  getApplicationMediaSourceView(applicationNumber) {
    return this.http.get(this.baseUrl + `application_MediaSource/view/${applicationNumber}/applicationNumber`);
  }
  getProgrammeChoiseView(applicationNumber) {
    return this.http.get(this.baseUrl + `application_ProgrammeChoise/view/${applicationNumber}/applicationNumber`);
  }

  getUndergraduateView(applicationNumber) {
    return this.http.get(this.baseUrl + `application_Undergraduate/view/${applicationNumber}/applicationNumber`);
  }
  getIJMBView(applicationNumber) {
    return this.http.get(this.baseUrl + `application_IJMB/view/${applicationNumber}/applicationNumber`);
  }
  downloadDocument(data) {
    return this.http.post(this.baseUrl + `admission_RequireDocument/download`,data);
  }
  getJAMBView(applicationNumber) {
    return this.http.get(this.baseUrl + `application_JAMB/view/${applicationNumber}/applicationNumber`);
  }
  sendOfferLetter(applicationNumber) {
    return this.http.get(this.baseUrl + `report/${applicationNumber}/applicationNumber`);
  }
  getTOCView(applicationNumber) {
    return this.http.get(this.baseUrl + `application_TOC/view/${applicationNumber}/applicationNumber`);
  }
  getChosenPrograms(applicationNumber) {
    return this.http.get(this.baseUrl + `application_ProgrammeChoise/required/${applicationNumber}/applicationNumber`);
  }  
    updateChosenPrograms(applicationNumber,data) {
    return this.http.put(this.baseUrl + `application_ProgrammeChoise/status/${applicationNumber}/applicationNumber`,data);
  } 
  
  UpdateApprovalAndSendOfferLetter(applicationNumber,data) {
    return this.http.put(this.baseUrl + `application_ProgrammeChoise/auto-offerletter/${applicationNumber}/applicationNumber`,data);
  }
 
  getAdmission_RequireDocument(applicationNumber,academicDegreeTypeId) {
    return this.http.get(this.baseUrl + `admission_RequireDocument/${applicationNumber}/applicationNumber/${academicDegreeTypeId}/academicDegreeTypeId`);
  }


  getocument(studentId) {
    return this.http.get(this.baseUrl + `admission_RequireDocument/${studentId}/studentId`);
  }


  getAdmin_Status(moduleName) {
    return this.http.get(this.baseUrl + `admin_Status/${moduleName}/moduleName`);
  }


  submitAcademic_TeachingMethod(data) {
    return this.http.post(this.baseUrl + `academic_TeachingMethod`,data);
  }
  getAcademic_TeachingMethod() {
    return this.http.get(this.baseUrl + `academic_TeachingMethod`);
  }

  deleteAcademic_TeachingMethod(academic_TeachingMethodId) {
    return this.http.delete(this.baseUrl + `academic_TeachingMethod/${academic_TeachingMethodId}/academic_TeachingMethodId`);
  }
  updateAcademic_TeachingMethod(data,academic_TeachingMethodId) {
    return this.http.put(this.baseUrl + `academic_TeachingMethod/${academic_TeachingMethodId}/academic_TeachingMethodId`, data);
  }

  submitAcademic_Block(data) {
    return this.http.post(this.baseUrl + `academic_Block`,data);
  }
  getAcademic_Block() {
    return this.http.get(this.baseUrl + `academic_Block`);
  }

  GetStudentActivityType() {
    return this.http.get(this.baseUrl + `academic_StudentActivityType`);
  }
  submitAcademic_StudentActivity(data) {
    return this.http.post(this.baseUrl + `academic_StudentActivity`,data);
  }
  getAcademic_BlockById(academicBlockId) {
    return this.http.get(this.baseUrl + `academic_Block/${academicBlockId}/academicBlockId`);
  }
  deleteAcademic_Block(academicBlockId) {
    return this.http.delete(this.baseUrl + `academic_Block/${academicBlockId}/academicBlockId`);
  }
  updateAcademic_Block(data,academicBlockId) {
    return this.http.put(this.baseUrl + `academic_Block/${academicBlockId}/academicBlockId`, data);
  }

  submitAcademic_BlockClassRoom(data) {
    return this.http.post(this.baseUrl + `academic_BlockClassRoom`,data);
  }
  getAcademic_BlockClassRoom() {
    return this.http.get(this.baseUrl + `academic_BlockClassRoom`);
  }
  getAcademicBlockClassRoom(academicBlockId) {
    return this.http.get(this.baseUrl + `academic_BlockClassRoom/${academicBlockId}/academicBlockId`);
  }
  getAcademic_BlockClassRoomById(academicClassroomId) {
    return this.http.get(this.baseUrl + `academic_BlockClassRoom/${academicClassroomId}/academicClassroomId`);
  }
  deleteAcademic_BlockClassRoom(academicClassroomId) {
    return this.http.delete(this.baseUrl + `academic_BlockClassRoom/${academicClassroomId}/academicClassroomId`);
  }
  updateAcademic_BlockClassRoom(data,academicClassroomId) {
    return this.http.put(this.baseUrl + `academic_BlockClassRoom/${academicClassroomId}/academicClassroomId`, data);
  }
  

  submitAcademic_TimeTable(data) {
    return this.http.post(this.baseUrl + `academic_TimeTable`,data);
  }
  submitAcademic_ExamTimeTable(data) {
    return this.http.post(this.baseUrl + `academic_TimeTable/exam`,data);
  }
  getAcademic_TimeTable() {
    return this.http.get(this.baseUrl + `academic_TimeTable`);
  }
  get_ProgrammeTimeTable(data) {
    return this.http.post(this.baseUrl + `academic_TimeTable/programme`,data);
  }
  get_ProgrammeTimeTableFaculty(data) {
    return this.http.post(this.baseUrl + `academic_TimeTable/faculty`,data);
  }

  dashboardSummary() {
    return this.http.get(this.baseUrl + `application_Student/dashboard`);
  }
  get_ProgrammeTimeTableHall(data) {
    return this.http.post(this.baseUrl + `academic_TimeTable/hall`,data);
  }
  getAcademic_TimeTableById(academicTimeTableId) {
    return this.http.get(this.baseUrl + `academic_TimeTable/${academicTimeTableId}/academicTimeTableId`);
  }
  deleteAcademic_TimeTable(academicTimeTableId) {
    return this.http.delete(this.baseUrl + `academic_TimeTable/${academicTimeTableId}/academicTimeTableId`);
  }
  updateAcademic_TimeTable(data,academicTimeTableId) {
    return this.http.put(this.baseUrl + `academic_TimeTable/${academicTimeTableId}/academicTimeTableId`, data);
  }


  searchCourseSchedule(terms: Observable<string>): any {
    return terms.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((term: string) => this.searchForCourseSchedule(term))
    );
  }

  searchForCourseSchedule(term: string): Observable<object> {
    if (term === '') {
      return of({});
    }
    const url = `${this.baseUrl + `academic_TimeTable/${term}/term`}`;
    return this.http.get(url);
  }


  submitAcademic_Week(data) {
    return this.http.post(this.baseUrl + `academic_Week`,data);
  }
  getAcademic_Week() {
    return this.http.get(this.baseUrl + `academic_Week`);
  }
  deleteAcademic_Week(weekId) {
    return this.http.delete(this.baseUrl + `academic_Week/${weekId}/weekId`);
  }
  updateAcademic_Week(data,weekId) {
    return this.http.put(this.baseUrl + `academic_Week/${weekId}/weekId`, data);
  }


  submitAcademic_CourseCurriculum(data) {
    return this.http.post(this.baseUrl + `academic_CourseCurriculum`,data);
  }
  getAcademic_CourseCurriculum() {
    return this.http.get(this.baseUrl + `academic_CourseCurriculum`);
  }
  getAcademic_CourseCurriculumByFaculty(employeeId) {
    return this.http.get(this.baseUrl + `academic_CourseCurriculum/${employeeId}/employeeId`);
  }
  getAcademic_CourseCurriculumBySession(academicSessionId) {
    return this.http.get(this.baseUrl + `academic_CourseCurriculum/${academicSessionId}/academicSessionId`);
  }
  getAcademic_CourseCurriculumByCourse(academicSessionId,term) {
    return this.http.get(this.baseUrl + `academic_CourseCurriculum/${academicSessionId}/academicSessionId/${term}/term`);
  }
  deleteAcademic_CourseCurriculum(courseCurriculumId) {
    return this.http.delete(this.baseUrl + `academic_CourseCurriculum/${courseCurriculumId}/courseCurriculumId`);
  }

  downloadCourseCurriculum(courseCurriculumId) {
    return this.http.get(this.baseUrl + `academic_CourseCurriculum/report/${courseCurriculumId}/courseCurriculumId`);
  }

  updateAcademic_CourseCurriculum(data,courseCurriculumId) {
    return this.http.put(this.baseUrl + `academic_CourseCurriculum/${courseCurriculumId}/courseCurriculumId`, data);
  }


  submitAcademic_ClassLessonPlan(data) {
    return this.http.post(this.baseUrl + `academic_ClassLessonPlan`,data);
  }
  getAcademic_ClassLessonPlan() {
    return this.http.get(this.baseUrl + `academic_ClassLessonPlan`);
  }
  getAcademic_ClassLessonPlanById(classLessonPlanId) {
    return this.http.get(this.baseUrl + `academic_ClassLessonPlan/${classLessonPlanId}/classLessonPlanId`);
  }
  deleteAcademic_ClassLessonPlan(classLessonPlanId) {
    return this.http.delete(this.baseUrl + `academic_ClassLessonPlan/${classLessonPlanId}/classLessonPlanId`);
  }
  updateAcademic_ClassLessonPlan(data,classLessonPlanId) {
    return this.http.put(this.baseUrl + `academic_ClassLessonPlan/${classLessonPlanId}/classLessonPlanId`, data);
  }


  

  getAcademic_TimeTableDay() {
    return this.http.get(this.baseUrl + `academic_TimeTableDay`);
  }
  getAcademic_TimeTablePeriod(timeTableDayId,academicClassroomId,timeTablePeriodId) {
    return this.http.get(this.baseUrl + `academic_TimeTablePeriod/${timeTableDayId}/timeTableDayId/${academicClassroomId}/academicClassroomId/${timeTablePeriodId}/timeTablePeriodId`);
  }

  getAcademicTimeTablePeriod() {
    return this.http.get(this.baseUrl + `academic_TimeTablePeriod`);
  }


  getAcademicUploads(activityReference) {
    return this.http.get(this.baseUrl + `academic_StudentActivityUpload/${activityReference}/activityReference`);
  }

  deleteAcademic_StudentActivityUpload(data,studentActivityUploadId) {
    return this.http.post(this.baseUrl + `academic_StudentActivityUpload/${studentActivityUploadId}/studentActivityUploadId`,data);
  }

  updateAcademic_StudentActivity(data,studentActivityId) {
    return this.http.put(this.baseUrl + `academic_StudentActivity/${studentActivityId}/studentActivityId`, data);
  }

  // uploadFile(formData) {
  //   //console.log('formData',formData);
    
  //   return this.http.post(this.baseUrl + `academic_StudentActivityUpload/PostUserImage`,formData);
  // }

  uploadFile(file: File, body: any): any {
    return new Promise((resolve, reject) => {
  
        let url = this.baseUrl + `academic_StudentActivityUpload/upload`;
        // let url = `${AppConstant.API_BASE}media/upload-file`;
        let xhr: XMLHttpRequest = new XMLHttpRequest();
  
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    resolve(JSON.parse(xhr.response));
                } else {
                    reject(xhr.response);
                }
            }
        };
  
        xhr.open('POST', url, true);
        let formData = new FormData();
  
        formData.append("file", file, file.name);
  
        for (var key in body) {
            formData.append(key, body[key]);
        }
  
        let loginResultDto = JSON.parse(localStorage.getItem('loginResultDto'));
        let token = loginResultDto.access_token;
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
  
        xhr.send(formData);
       return xhr.response;
    });
  }
  
  uploadExcelFile(file: File, academicCourseDefinitionId: any, academicSessionId :any, academicCourseAssessmentTypeSettingId:any,academicDegreeProgrammeId:any): any {
    return new Promise((resolve, reject) => {
  
        let url = this.baseUrl + `academic_GraduationPlan/result-import/${academicCourseDefinitionId}/academicCourseDefinitionId/${academicDegreeProgrammeId}/academicDegreeProgrammeId/${academicSessionId}/academicSessionId/${academicCourseAssessmentTypeSettingId}/academicCourseAssessmentTypeSettingId`;
        // let url = `${AppConstant.API_BASE}media/upload-file`;
        let xhr: XMLHttpRequest = new XMLHttpRequest();
  
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    resolve(JSON.parse(xhr.response));
                } else {
                    reject(xhr.response);
                }
            }
        };
  
        xhr.open('POST', url, true);
        let formData = new FormData();
  
        formData.append("file", file, file.name);
  
        let loginResultDto = JSON.parse(localStorage.getItem('loginResultDto'));
        let token = loginResultDto.access_token;
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
  
        xhr.send(formData);
       return xhr.response;
    });
  }

   uploadDirectExcelFile(file: File, academicCourseDefinitionId: any, academicSessionId :any, academicSemesterId:any): any {
    return new Promise((resolve, reject) => {
  
        let url = this.baseUrl + `academic_ResultDirectPosting/result-import/${academicCourseDefinitionId}/academicCourseDefinitionId/${academicSessionId}/academicSessionId/${academicSemesterId}/academicSemesterId`;
        // let url = `${AppConstant.API_BASE}media/upload-file`;
        let xhr: XMLHttpRequest = new XMLHttpRequest();
  
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    resolve(JSON.parse(xhr.response));
                } else {
                    reject(xhr.response);
                }
            }
        };
  
        xhr.open('POST', url, true);
        let formData = new FormData();
  
        formData.append("file", file, file.name);
  
        let loginResultDto = JSON.parse(localStorage.getItem('loginResultDto'));
        let token = loginResultDto.access_token;
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
  
        xhr.send(formData);
       return xhr.response;
    });
  }

  getdAssessmentFileUploads(assessmentActivityReference) {
    return this.http.get(this.baseUrl + `academic_AssessmentActivityUpload/${assessmentActivityReference}/assessmentActivityReference`);
  }



  uploadAssessmentFile(file: File, body: any): any {
    return new Promise((resolve, reject) => {
  
        let url = this.baseUrl + `academic_AssessmentActivityUpload/upload`;
        // let url = `${AppConstant.API_BASE}media/upload-file`;
        let xhr: XMLHttpRequest = new XMLHttpRequest();
  
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    resolve(JSON.parse(xhr.response));
                } else {
                    reject(xhr.response);
                }
            }
        };
  
        xhr.open('POST', url, true);
        let formData = new FormData();
  
        formData.append("file", file, file.name);
  
        for (var key in body) {
            formData.append(key, body[key]);
        }
  
        let loginResultDto = JSON.parse(localStorage.getItem('loginResultDto'));
        let token = loginResultDto.access_token;
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
  
        xhr.send(formData);
       return xhr.response;
    });
  }

  deleteAcademic_StudentActivity(studentActivityId) {
    return this.http.delete(this.baseUrl + `academic_StudentActivity/${studentActivityId}/studentActivityId`);
  }

  deleteAcademic_AssessmentActivityUpload(assessmentActivityUploadId) {
    return this.http.delete(this.baseUrl + `academic_AssessmentActivityUpload/${assessmentActivityUploadId}/assessmentActivityUploadId`);
  }

  submitAcademic_AssessmentActivity(data) {
    return this.http.post(this.baseUrl + `academic_AssessmentActivity`,data);
  }
  getAcademic_AssessmentActivity() {
    return this.http.get(this.baseUrl + `academic_AssessmentActivity`);
  }
  getAcademicAssessmentActivity(academicCourseScheduleId) {
    return this.http.get(this.baseUrl + `academic_AssessmentActivity/${academicCourseScheduleId}/academicCourseScheduleId`);
  }
  deleteAcademic_AssessmentActivity(assessmentActivityId) {
    return this.http.delete(this.baseUrl + `academic_AssessmentActivity/${assessmentActivityId}/assessmentActivityId`);
  }
  updateAcademic_AssessmentActivity(data,assessmentActivityId) {
    return this.http.put(this.baseUrl + `academic_AssessmentActivity/${assessmentActivityId}/assessmentActivityId`, data);
  }

  getAcademic_AssessmentActivityType() {
    return this.http.get(this.baseUrl + `academic_AssessmentActivityType`);
  }



  submitAcademic_SeatAllocation(data) {
    return this.http.post(this.baseUrl + `academic_SeatAllocation`,data);
  }
  getAcademic_SeatAllocation() {
    return this.http.get(this.baseUrl + `academic_SeatAllocation`);
  }

  deleteAcademic_SeatAllocation(seatAllocationId) {
    return this.http.delete(this.baseUrl + `academic_SeatAllocation/${seatAllocationId}/seatAllocationId`);
  }
  updateAcademic_SeatAllocation(data,seatAllocationId) {
    return this.http.put(this.baseUrl + `academic_SeatAllocation/${seatAllocationId}/seatAllocationId`, data);
  }


  submitAcademic_IntakeMaster(data) {
    return this.http.post(this.baseUrl + `academic_IntakeMaster`,data);
  }
  getAcademic_IntakeMaster() {
    return this.http.get(this.baseUrl + `academic_IntakeMaster`);
  }

  deleteAcademic_IntakeMaster(intakeId) {
    return this.http.delete(this.baseUrl + `academic_IntakeMaster/${intakeId}/intakeId`);
  }
  updateAcademic_IntakeMaster(data,intakeId) {
    return this.http.put(this.baseUrl + `academic_IntakeMaster/${intakeId}/intakeId`, data);
  }
  
  getProgrammeTimeTable(data) {
    return this.http.post(this.baseUrl + `report/timetable`,data);
  }
  get_TimeTableFaculty(data) {
    return this.http.post(this.baseUrl + `report/faculty`,data);
  }

  get_TimeTableHall(data) {
    return this.http.post(this.baseUrl + `report/hall`,data);
  }


  submitAcademic_ResultApprovalLevel(data) {
    return this.http.post(this.baseUrl + `academic_ResultApprovalLevel`,data);
  }
  getAcademic_ResultApprovalLevel() {
    return this.http.get(this.baseUrl + `academic_ResultApprovalLevel`);
  }

  deleteAcademic_ResultApprovalLevel(resultApprovalLevelId) {
    return this.http.delete(this.baseUrl + `academic_ResultApprovalLevel/${resultApprovalLevelId}/resultApprovalLevelId`);
  }
  updateAcademic_ResultApprovalLevel(data,resultApprovalLevelId) {
    return this.http.put(this.baseUrl + `academic_ResultApprovalLevel/${resultApprovalLevelId}/resultApprovalLevelId`, data);
  }


  submitAcademic_ResultApprovalSetup(data) {
    return this.http.post(this.baseUrl + `academic_ResultApprovalSetup`,data);
  }
  getAcademic_ResultApprovalSetup() {
    return this.http.get(this.baseUrl + `academic_ResultApprovalSetup`);
  }

  getResultApprovalList(academicDegreeTypeId, academicFacultyId, academicDepartmentId, academicSessionId) {
    return this.http.get(this.baseUrl + `academic_ResultApprovalSetup/${academicDegreeTypeId}/academicDegreeTypeId/${academicFacultyId}/academicFacultyId/${academicDepartmentId}/academicDepartmentId/${academicSessionId}/academicSessionId`);
  }

  deleteAcademic_ResultApprovalSetup(resultApprovalSetupId) {
    return this.http.delete(this.baseUrl + `academic_ResultApprovalSetup/${resultApprovalSetupId}/resultApprovalSetupId`);
  }
  updateAcademic_ResultApprovalSetup(data,resultApprovalSetupId) {
    return this.http.put(this.baseUrl + `academic_ResultApprovalSetup/${resultApprovalSetupId}/resultApprovalSetupId`, data);
  }

  submitPg_PostgraduateSpecialization(data) {
    return this.http.post(this.baseUrl + `pg_PostgraduateSpecialization`,data);
  }
  getPg_PostgraduateSpecialization(admissionProgrammeId) {
    return this.http.get(this.baseUrl + `pg_PostgraduateSpecialization/${admissionProgrammeId}/admissionProgrammeId`);
  }

  deletePg_PostgraduateSpecialization(postgraduateSpecializationId) {
    return this.http.delete(this.baseUrl + `pg_PostgraduateSpecialization/${postgraduateSpecializationId}/postgraduateSpecializationId`);
  }
  updatePg_PostgraduateSpecialization(data,postgraduateSpecializationId) {
    return this.http.put(this.baseUrl + `pg_PostgraduateSpecialization/${postgraduateSpecializationId}/postgraduateSpecializationId`, data);
  }

  submitPg_AdmissionProgrammes(data) {
    return this.http.post(this.baseUrl + `pg_AdmissionProgrammes`,data);
  }
  getPg_AdmissionProgrammes() {
    return this.http.get(this.baseUrl + `pg_AdmissionProgrammes`);
  }
  deletePg_AdmissionProgrammes(pg_AdmissionProgrammesId) {
    return this.http.delete(this.baseUrl + `pg_AdmissionProgrammes/${pg_AdmissionProgrammesId}/pg_AdmissionProgrammesId`);
  }
  updatePg_AdmissionProgrammes(data,pg_AdmissionProgrammesId) {
    return this.http.put(this.baseUrl + `pg_AdmissionProgrammes/${pg_AdmissionProgrammesId}/pg_AdmissionProgrammesId`, data);
  }


  getPg_Alevel(applicationNumber) {
    return this.http.get(this.baseUrl + `pg_Alevel/${applicationNumber}/applicationNumber`);
  }
  getPg_ProjectAndThesis(applicationNumber) {
    return this.http.get(this.baseUrl + `pg_ProjectAndThesis/${applicationNumber}/applicationNumber`);
  }
  getPg_Journal(applicationNumber) {
    return this.http.get(this.baseUrl + `pg_Journal/${applicationNumber}/applicationNumber`);
  }
  getPg_Conference(applicationNumber) {
    return this.http.get(this.baseUrl + `pg_Conference/${applicationNumber}/applicationNumber`);
  }
  getPg_ProfessionalQualification(applicationNumber) {
    return this.http.get(this.baseUrl + `pg_ProfessionalQualification/${applicationNumber}/applicationNumber`);
  }
  getPg_WorkExperience(applicationNumber) {
    return this.http.get(this.baseUrl + `pg_WorkExperience/${applicationNumber}/applicationNumber`);
  }
  getPg_AdditionalSkill(applicationNumber) {
    return this.http.get(this.baseUrl + `pg_AdditionalSkill/${applicationNumber}/applicationNumber`);
  }

  submitAcademic_ResultApprovalLevelType(data) {
    return this.http.post(this.baseUrl + `academic_ResultApprovalLevelType`,data);
  }
  getAcademic_ResultApprovalLevelType() {
    return this.http.get(this.baseUrl + `academic_ResultApprovalLevelType`);
  }
  deleteAcademic_ResultApprovalLevelType(approvalLevelTypeId) {
    return this.http.delete(this.baseUrl + `academic_ResultApprovalLevelType/${approvalLevelTypeId}/approvalLevelTypeId`);
  }
  updateAcademic_ResultApprovalLevelType(data,approvalLevelTypeId) {
    return this.http.put(this.baseUrl + `academic_ResultApprovalLevelType/${approvalLevelTypeId}/approvalLevelTypeId`, data);
  }

  submitApprovedResults(data) {
    return this.http.post(this.baseUrl + `academic_ResultApproval/submit-approval`,data);
  }

  submitMergeResult(data) {
    return this.http.post(this.baseUrl + `academic_GraduationPlan/merge-result`,data);
  }

  updateAndDropCoursesForChangeOfProgramStudents(data) {
    return this.http.put(this.baseUrl + `academic_GraduationPlan/course-reconsiliation`,data);
  }

  gradeReCalculation(data) {
    return this.http.post(this.baseUrl + `academic_GraduationPlan/calculate-grade`,data);
  }

  submitAcademic_ResultApproval(data) {
    return this.http.post(this.baseUrl + `academic_ResultApproval`,data);
  }
  submitAcademic_DirectResultApproval(data) {
    return this.http.post(this.baseUrl + `academic_ResultApproval/direct`,data);
  }
  getAcademic_ResultApproval() {
    return this.http.get(this.baseUrl + `academic_ResultApproval`);
  }

  deleteAcademic_ResultApproval(resultApprovalId) {
    return this.http.delete(this.baseUrl + `academic_ResultApproval/${resultApprovalId}/resultApprovalId`);
  }
  updateAcademic_ResultApproval(data,resultApprovalId) {
    return this.http.put(this.baseUrl + `academic_ResultApproval/${resultApprovalId}/resultApprovalId`, data);
  }
  updateStudentScreeningExercise(applicationNumber,data) {
    return this.http.put(this.baseUrl + `application_student/screening/${applicationNumber}/applicationNumber`,data);
  }
  getSenateResultApproval(academicDegreeProgrammeId,academicSemesterId,academicSessionId,academicLevelId) {
    return this.http.get(this.baseUrl + `academic_GraduationPlan/senate/${academicDegreeProgrammeId}/academicDegreeProgrammeId/${academicSemesterId}/academicSemesterId/${academicSessionId}/academicSessionId/${academicLevelId}/academicLevelId`);
  }


  submitAcademic_TimeTableInvigilation(data) {
    return this.http.post(this.baseUrl + `academic_TimeTableInvigilation`,data);
  }
  getAcademic_TimeTableInvigilation(academicTimeTableId) {
    return this.http.get(this.baseUrl + `academic_TimeTableInvigilation/${academicTimeTableId}/academicTimeTableId`);
  }
  deleteAcademic_TimeTableInvigilation(invigilationId) {
    return this.http.delete(this.baseUrl + `academic_TimeTableInvigilation/${invigilationId}/invigilationId`);
  }
  updateAcademic_TimeTableInvigilation(data,timeTableInvigilationId) {
    return this.http.put(this.baseUrl + `academic_TimeTableInvigilation/${timeTableInvigilationId}/timeTableInvigilationId`, data);
  }

  submitAcademic_GradingTemplate(data) {
    return this.http.post(this.baseUrl + `academic_GradingTemplate`,data);
  }
  getAcademic_GradingTemplate() {
    return this.http.get(this.baseUrl + `academic_GradingTemplate`);
  }

  deleteAcademic_GradingTemplate(gradingTemplateId) {
    return this.http.delete(this.baseUrl + `academic_GradingTemplate/${gradingTemplateId}/gradingTemplateId`);
  }
  updateAcademic_GradingTemplate(data,gradingTemplateId) {
    return this.http.put(this.baseUrl + `academic_GradingTemplate/${gradingTemplateId}/gradingTemplateId`, data);
  }

  submitAcademic_GradingTemplateMapping(data) {
    return this.http.post(this.baseUrl + `academic_GradingTemplateMapping`,data);
  }
  getAcademic_GradingTemplateMapping(academicDegreeProgrammeId) {
    return this.http.get(this.baseUrl + `academic_GradingTemplateMapping/${academicDegreeProgrammeId}/academicDegreeProgrammeId`);
  }
 
  deleteAcademic_GradingTemplateMapping(gradingTemplateMappingId) {
    return this.http.delete(this.baseUrl + `academic_GradingTemplateMapping/${gradingTemplateMappingId}/gradingTemplateMappingId`);
  }
  updateAcademic_GradingTemplateMapping(data,gradingTemplateMappingId) {
    return this.http.put(this.baseUrl + `academic_GradingTemplateMapping/${gradingTemplateMappingId}/gradingTemplateMappingId`, data);
  }


  submitAcademic_DeferredSemesterType(data) {
    return this.http.post(this.baseUrl + `academic_DeferredSemesterType`,data);
  }
  getAcademic_DeferredSemesterType() {
    return this.http.get(this.baseUrl + `academic_DeferredSemesterType`);
  }
  deleteAcademic_DeferredSemesterType(deferredSemesterTypeId) {
    return this.http.delete(this.baseUrl + `academic_DeferredSemesterType/${deferredSemesterTypeId}/deferredSemesterTypeId`);
  }
  updateAcademic_DeferredSemesterType(data,deferredSemesterTypeId) {
    return this.http.put(this.baseUrl + `academic_DeferredSemesterType/${deferredSemesterTypeId}/deferredSemesterTypeId`, data);
  }


  submitAcademic_Deferral(data) {
    return this.http.post(this.baseUrl + `academic_Deferral`,data);
  }
  getAcademic_Deferral() {
    return this.http.get(this.baseUrl + `academic_Deferral`);
  }
  deleteAcademic_Deferral(deferralId) {
    return this.http.delete(this.baseUrl + `academic_Deferral/${deferralId}/deferralId`);
  }
  updateAcademic_Deferral(data,deferralId) {
    return this.http.put(this.baseUrl + `academic_Deferral/${deferralId}/deferralId`, data);

  }

  submitAcademic_ExaminationExcuseAbsent(data) {
    return this.http.post(this.baseUrl + `academic_ExaminationExcuseAbsent`,data);
  }
  getAcademic_ExaminationExcuseAbsent() {
    return this.http.get(this.baseUrl + `academic_ExaminationExcuseAbsent`);
  }

  deleteAcademic_ExaminationExcuseAbsent(examinationExcuseAbsentId) {
    return this.http.delete(this.baseUrl + `academic_ExaminationExcuseAbsent/${examinationExcuseAbsentId}/examinationExcuseAbsentId`);
  }
  updateAcademic_ExaminationExcuseAbsent(data,examinationExcuseAbsentId) {
    return this.http.put(this.baseUrl + `academic_ExaminationExcuseAbsent/${examinationExcuseAbsentId}/examinationExcuseAbsentId`, data);
  }


  submitAcademic_ExaminationExcuseType(data) {
    return this.http.post(this.baseUrl + `academic_ExaminationExcuseType`,data);
  }
  getAcademic_ExaminationExcuseType() {
    return this.http.get(this.baseUrl + `academic_ExaminationExcuseType`);
  }
  deleteAcademic_ExaminationExcuseType(examinationExcuseTypeId) {
    return this.http.delete(this.baseUrl + `academic_ExaminationExcuseType/${examinationExcuseTypeId}/examinationExcuseTypeId`);
  }
  updateAcademic_ExaminationExcuseType(data,examinationExcuseTypeId) {
    return this.http.put(this.baseUrl + `academic_ExaminationExcuseType/${examinationExcuseTypeId}/examinationExcuseTypeId`, data);
  }


  submitAcademic_CoursesAsSubject(data) {
    console.log('pass here ');
    
    return this.http.post(this.baseUrl + `academic_CoursesAsSubject`,data);
  }
  getAcademic_CoursesAsSubject(academicCourseSubjectId,academicDegreeProgrammeId) {
    return this.http.get(this.baseUrl + `academic_CoursesAsSubject/${academicCourseSubjectId}/academicCourseSubjectId/${academicDegreeProgrammeId}/academicDegreeProgrammeId`);
  }
  getAcademic_CoursesAsSubjectByDept(academicDegreeProgrammeId) {
    return this.http.get(this.baseUrl + `academic_CoursesAsSubject/${academicDegreeProgrammeId}/academicDegreeProgrammeId`);
  }
  deleteAcademic_CoursesAsSubject(coursesAsSubjectId) {
    return this.http.delete(this.baseUrl + `academic_CoursesAsSubject/${coursesAsSubjectId}/coursesAsSubjectId`);
  }
  updateAcademic_CoursesAsSubject(data,coursesAsSubjectId) {
    return this.http.put(this.baseUrl + `academic_CoursesAsSubject/${coursesAsSubjectId}/coursesAsSubjectId`, data);
  }


  submitAcademic_CourseSubject(data) {
    return this.http.post(this.baseUrl + `academic_CourseSubject`,data);
  }
  getAcademic_CourseSubject() {
    return this.http.get(this.baseUrl + `academic_CourseSubject`);
  }
  deleteAcademic_CourseSubject(courseSubjectId) {
    return this.http.delete(this.baseUrl + `academic_CourseSubject/${courseSubjectId}/courseSubjectId`);
  }
  updateAcademic_CourseSubject(data,courseSubjectId) {
    return this.http.put(this.baseUrl + `academic_CourseSubject/${courseSubjectId}/courseSubjectId`, data);
  }

  getResultUploadStatus(academicSessionId,academicDegreeProgrammeId,academicLevelId,academicSemesterId) {
    return this.http.get(this.baseUrl + `academic_ResultPosting/result-upload-status/${academicSessionId}/academicSessionId/${academicDegreeProgrammeId}/academicDegreeProgrammeId/${academicLevelId}/academicLevelId/${academicSemesterId}/academicSemesterId`);
  }
}



